var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language"},[_c('div',{staticClass:"language__option",class:{
      'language__option--active': _vm.languageLocal
    },on:{"click":function($event){return _vm.handleEmitLanguage(true)}}},[_c('EUAIcon',{staticClass:"language__icon"})],1),_c('div',{staticClass:"language__option",class:{
      'language__option--active': !_vm.languageLocal
    },on:{"click":function($event){return _vm.handleEmitLanguage(false)}}},[_c('SpainIcon',{staticClass:"language__icon"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }